import { DEMO_NOW } from '../data/seed';

export const isDemo: boolean = (import.meta.env.VITE_DATA_MODE ?? 'demo') !== 'api';

// In demo mode the clock starts at DEMO_NOW and then advances in real time,
// so countdowns tick while seed dates stay coherent.
const offset = isDemo ? Date.parse(DEMO_NOW) - Date.now() : 0;

export const now = (): number => Date.now() + offset;
export const nowIso = (): string => new Date(now()).toISOString();
